module.exports = __webpack_public_path__ + "img/garlic.b72483b2.svg";